import { render, staticRenderFns } from "./JobInfoModal.vue?vue&type=template&id=2c13f608"
import script from "./JobInfoModal.vue?vue&type=script&lang=js"
export * from "./JobInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports